import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Footer from "@/components/Footer";

export default function Terms() {
  const lastUpdated = "May 7, 2026";

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 max-w-4xl mx-auto px-6 py-20 lg:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="eyebrow text-muted-foreground mb-4 text-center">Legal · Inkspot</div>
          <h1 className="font-serif text-5xl sm:text-7xl font-black tracking-tight text-center mb-8">
            Terms of Service.
          </h1>
          <div className="text-center text-sm text-muted-foreground mb-16 italic">
            Last updated: {lastUpdated}
          </div>

          <div className="prose prose-neutral dark:prose-invert max-w-none space-y-12 text-foreground/90">
            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">1. Agreement to Terms</h2>
              <p className="leading-relaxed">
                By accessing or using Inkspot, you agree to be bound by these Terms of Service. If you do not 
                agree to all these terms, do not use the service.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">2. Your Content</h2>
              <p className="leading-relaxed">
                You retain all ownership rights to the content you publish on Inkspot. By publishing on our platform, 
                you grant us a non-exclusive, royalty-free, worldwide license to display, distribute, and promote 
                your content as part of the Inkspot service.
              </p>
              <p className="mt-4">
                You are solely responsible for the content you publish and the consequences of posting it.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">3. Acceptable Use</h2>
              <p className="leading-relaxed">
                You agree not to use Inkspot to:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Publish content that is illegal, harmful, or promotes hate speech.</li>
                <li>Harass or intimidate other users.</li>
                <li>Impersonate others or provide misleading information.</li>
                <li>Distribute malware or engage in spamming activities.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">4. Accounts</h2>
              <p className="leading-relaxed">
                You are responsible for maintaining the security of your account and password. Inkspot 
                cannot and will not be liable for any loss or damage from your failure to comply with this 
                security obligation.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">5. Termination</h2>
              <p className="leading-relaxed">
                We reserve the right to terminate or suspend your account and access to the service at our 
                sole discretion, without notice, for conduct that we believe violates these Terms or is harmful 
                to other users or our business interests.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-3xl font-bold tracking-tight mb-4 border-b border-border pb-2">6. Limitation of Liability</h2>
              <p className="leading-relaxed">
                Inkspot is provided "as is" without any warranties. We shall not be liable for any indirect, 
                incidental, special, consequential, or punitive damages resulting from your use of the service.
              </p>
            </section>

            <section className="bg-card border border-border p-8 mt-20">
              <h2 className="font-serif text-2xl font-bold mb-4">Contact</h2>
              <p className="text-sm text-muted-foreground mb-6">
                If you have any questions about these Terms, please contact our legal team.
              </p>
              <Link to="/contact" className="link-underline text-foreground font-medium">Contact Us</Link>
            </section>
          </div>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
}
